import { createIcon } from '../createIcon.tsx';

export const PlayIcon = createIcon('PlayIcon', <polygon points="6 4 20 12 6 20 6 4" />);
